import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const StockSummaryServices = {
  getList: async () => {
    const response = await apiService.get(`${slug}/stock-report/getstockitems`);
    return response.data;
  },
  getStockItemList: async (id) => {
    const response = await apiService.get(
      `${slug}/stock-report/getstockitemdetails/${id}`
    );
    return response.data;
  },

  menuItemAdjust: async (data ) => {
    const response = await apiService.post(`/${slug}/menuitemsadjustmentlogs`, data);
    return response.data;
  },
};

export default StockSummaryServices;
